
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IBudgetAdjustment, IDocument, ISaveAdjustmentCriteria } from "@tylertech/tyler-api-types";

/**
 * BudgetAdjustmentService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class BudgetAdjustmentService {
    constructor(private readonly $apiService: ApiService) { }
    
    CanUserSubmitBudgetAdjustments(budgetAdjustmentId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/CanUserSubmitBudgetAdjustments", budgetAdjustmentId);
    }
    Delete(adjustment: IBudgetAdjustment): Promise<boolean> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/Delete", adjustment);
    }
    GenerateNewNumber(): Promise<string> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/GenerateNewNumber");
    }
    GetOpenAdjustments(budgetCodeFiscalId: string): Promise<IBudgetAdjustment[]> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/GetOpenAdjustments", budgetCodeFiscalId);
    }
    PrintReport(adjustment: IBudgetAdjustment): Promise<IDocument> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/PrintReport", adjustment);
    }
    RequiresApproval(budgetAdjustmentId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/RequiresApproval", budgetAdjustmentId);
    }
    Save(criteria: ISaveAdjustmentCriteria): Promise<IBudgetAdjustment> {
        return this.$apiService.sendAuth("IBudgetAdjustmentService/Save", criteria);
    }
}
